import isNode from 'detect-node';
import loadSummaries from './load-summaries.js';

const pageSize = 10;

const summaries = [
  () => import('../components/summaries/summary-2021-03-28-signed-new-contract.js'),
  () => import('../components/summaries/summary-2021-03-03-looking-for-contract.js'),
  () => import('../components/summaries/summary-2017-09-12-hi.js')
];

export default function (pageNumber, callback = () => {}) {
  return (dispatch) => {
    const pageStart = (pageNumber - 1) * pageSize;
    const pageEnd = pageNumber * pageSize;

    Promise
      .all(summaries.slice(pageStart, pageEnd).map((summaryThunk) => summaryThunk()))
      .then( summariesNs => {
        const summaries = summariesNs.map(summary => {
          if(typeof summary.default == 'undefined') {
            return summary;
          } else {
            return summary.default;
          }
        });
        dispatch(loadSummaries(pageNumber, summaries, summaries.length));
        callback(summaries);
      });
  };
}
